<template>
	<v-dialog
		v-model="dialog"
		max-width="600"
		persistent
		scrollable
	>
		<v-card>
			<v-card-title class="d-flex justify-space-between align-center">
				<span style="font-size: 24px; font-weight: 700; color: #141414;">
					Convite de Liderança
				</span>
				<v-btn
					icon
					@click="closeDialog"
					:disabled="loading"
				>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-card-title>

			<v-card-text>
				<div v-if="conviteLideranca">
					<p style="color: #4d4d4d; margin-bottom: 24px; font-size: 15px;">
						Você recebeu um convite para ser <strong>liderança</strong> do grupo 
						<strong>{{ conviteLideranca.grupoNome }}</strong>.
					</p>

					<v-alert
						type="info"
						dense
						text
						class="mb-4"
					>
						Ao aceitar este convite, as publicações feitas no seu grupo de Eleitores 
						serão compartilhadas também no grupo de quem convidou.
					</v-alert>

					<v-card
						class="mb-4"
						elevation="1"
						style="background-color: #f5f5f5;"
					>
						<v-card-text>
							<h4 style="font-size: 16px; font-weight: 600; color: #141414; margin-bottom: 12px;">
								Detalhes do Convite
							</h4>
							<v-list dense>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-subtitle>Grupo</v-list-item-subtitle>
										<v-list-item-title>{{ conviteLideranca.grupoNome }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
								<v-list-item>
									<v-list-item-content>
										<v-list-item-subtitle>Convidado por</v-list-item-subtitle>
										<v-list-item-title>{{ conviteLideranca.convidadoPor }}</v-list-item-title>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-card-text>
					</v-card>
				</div>
			</v-card-text>

			<v-card-actions class="d-flex justify-space-between">
				<v-btn
					text
					@click="recusarConvite"
					:disabled="loading"
					color="error"
				>
					Recusar
				</v-btn>
				<v-btn
					color="#F15A24"
					dark
					@click="aceitarConvite"
					:loading="loading"
					:disabled="loading"
				>
					Aceitar Convite
				</v-btn>
			</v-card-actions>

			<v-snackbar
				v-model="snackbar"
				:color="snackbarColor"
				timeout="3000"
				top
			>
				{{ snackbarText }}
				<template v-slot:action="{ attrs }">
					<v-btn
						text
						v-bind="attrs"
						@click="snackbar = false"
					>
						Fechar
					</v-btn>
				</template>
			</v-snackbar>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: 'DialogAceitarLideranca',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		convite: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			dialog: this.value,
			loading: false,
			snackbar: false,
			snackbarText: '',
			snackbarColor: 'success',
			conviteLideranca: null,
		};
	},
	watch: {
		value(newVal) {
			this.dialog = newVal;
			if (newVal && this.convite) {
				this.carregarDadosConvite();
			}
		},
		dialog(newVal) {
			this.$emit('input', newVal);
		},
		convite(newVal) {
			if (newVal && this.dialog) {
				this.carregarDadosConvite();
			}
		},
	},
	methods: {
		async carregarDadosConvite() {
			if (!this.convite) {
				this.mostrarSnackbar('Erro: Dados do convite inválidos.', 'error');
				return;
			}

			try {
				// O ID do grupo já vem como string de equipeDetalhe.vue
				let grupoId = this.convite.id_grupo;
				
				// Se ainda for objeto, tentar extrair o ID
				if (typeof grupoId === 'object' && grupoId !== null) {
					grupoId = grupoId.id || grupoId.id_grupo || grupoId;
				}
				
				// Converter para string e validar
				grupoId = grupoId ? String(grupoId) : null;

				if (!grupoId || grupoId === 'undefined' || grupoId === 'null' || grupoId.trim() === '') {
					this.mostrarSnackbar('Erro: ID do grupo não encontrado no convite.', 'error');
					return;
				}

				// Buscar informações do grupo e do usuário que convidou
				const { data: grupoData } = await this.$http.get(
					`items/grupos/${grupoId}?fields=nome_grupo,user_created.first_name,user_created.last_name,user_created.id`
				);

				if (!grupoData.data) {
					this.mostrarSnackbar('Erro: Grupo não encontrado.', 'error');
					return;
				}

				this.conviteLideranca = {
					id: this.convite.id,
					grupoId: grupoId,
					grupoNome: grupoData.data.nome_grupo || 'Grupo de Eleitores',
					convidadoPor: grupoData.data.user_created 
						? `${grupoData.data.user_created.first_name || ''} ${grupoData.data.user_created.last_name || ''}`.trim()
						: 'Usuário',
				};
			} catch (error) {
				// Erro ao carregar dados do convite
				this.mostrarSnackbar('Erro ao carregar informações do convite.', 'error');
			}
		},
		mostrarSnackbar(text, color = 'success') {
			this.snackbarText = text;
			this.snackbarColor = color;
			this.snackbar = true;
		},
		async aceitarConvite() {
			if (!this.conviteLideranca) return;

			this.loading = true;

			try {
				// 1. Atualizar status do convite para aceito
				await this.$http.patch(`items/add_grupos/${this.conviteLideranca.id}`, {
					status: 'aceito',
				});

				// 2. Salvar informação no campo 'lideranca' do grupo que convidou
				// O campo lideranca deve conter o ID do grupo de Eleitores do usuário que aceitou
				const meuGrupoEleitores = await this.buscarMeuGrupoEleitores();
				
				if (meuGrupoEleitores && meuGrupoEleitores.id) {
					// O campo lideranca é um relacionamento Many-to-One (foreign key)
					// O Directus geralmente aceita o ID como string ou número para foreign keys
					const liderancaId = meuGrupoEleitores.id;
					
					// Verificar se o grupo de liderança existe antes de tentar salvar
					try {
						const { data: grupoLideranca } = await this.$http.get(
							`items/grupos/${liderancaId}?fields=id`
						);
						
						if (!grupoLideranca.data || !grupoLideranca.data.id) {
							this.mostrarSnackbar('Erro: Grupo de liderança não encontrado.', 'error');
							return;
						}
					} catch (err) {
						this.mostrarSnackbar('Erro: Não foi possível validar o grupo de liderança.', 'error');
						return;
					}
					
					// Atualizar o campo lideranca com o ID do grupo de Eleitores do usuário que aceitou
					// Para relacionamentos Many-to-One no Directus, usar formato de objeto com id
					await this.$http.patch(`items/grupos/${this.conviteLideranca.grupoId}`, {
						lideranca: { id: liderancaId },
					});

					this.mostrarSnackbar('Convite aceito com sucesso! As publicações serão compartilhadas.', 'success');
					
					// Recarregar informações do usuário
					await this.$store.dispatch('getInfo');
					
					// Fechar dialog após um breve delay
					setTimeout(() => {
						this.closeDialog();
					}, 1500);
				} else {
					this.mostrarSnackbar('Erro: Grupo de Eleitores não encontrado.', 'error');
				}
			} catch (error) {
				// Erro ao aceitar convite - mostrar mensagem mais detalhada
				if (error.response && error.response.data) {
					const errors = error.response.data.errors;
					const errorMsg = (errors && errors.length > 0 && errors[0].message) 
						? errors[0].message 
						: 'Erro ao aceitar convite.';
					this.mostrarSnackbar(`Erro: ${errorMsg}`, 'error');
				} else {
					this.mostrarSnackbar('Erro ao aceitar convite. Tente novamente.', 'error');
				}
			} finally {
				this.loading = false;
			}
		},
		async recusarConvite() {
			if (!this.conviteLideranca) return;

			this.loading = true;

			try {
				// Atualizar status do convite para recusado
				await this.$http.patch(`items/add_grupos/${this.conviteLideranca.id}`, {
					status: 'recusado',
				});

				this.mostrarSnackbar('Convite recusado.', 'info');
				
				setTimeout(() => {
					this.closeDialog();
				}, 1000);
			} catch (error) {
				// Erro ao recusar convite
				this.mostrarSnackbar('Erro ao recusar convite. Tente novamente.', 'error');
			} finally {
				this.loading = false;
			}
		},
		async buscarMeuGrupoEleitores() {
			try {
				const { data } = await this.$http.get(
					`items/grupos?filter[user_created][_eq]=${this.$store.state.user.id}&filter[nome_grupo][_contains]=Eleitores&fields=id`
				);

				if (data.data && data.data.length > 0) {
					return data.data[0];
				}
				return null;
			} catch (error) {
				return null;
			}
		},
		closeDialog() {
			this.dialog = false;
		},
	},
};
</script>

<style scoped>
</style>

